// import "wow.js";
// import "slick-carousel";

(function ($) {
	$(function () {
		// calculate viewport width
		const style = document.createElement("style");
		style.id = "viewport-width";
		const calculateViewportWidth = () => {
			const width = document.documentElement.clientWidth;
			style.innerHTML = `:root { --viewport-width: ${width}px; }`;
		};
		document.head.appendChild(style);
		calculateViewportWidth();

		$(document).ready(function () {
			const ob = new ResizeObserver(calculateViewportWidth);
			ob.observe(document.documentElement);
		});

		$("h1, h2, h3, h4, h5, h6").each(function () {
			if (!$(this).children().length) {
				$(this).wrapInner("<span />");
			}
		});

		if ($.isFunction($.fn.slick)) {
			console.log("working");
		}

		var width_screen = $(window).width();
		if (767 < width_screen) {
			WOW.prototype.addBox = function (element) {
				this.boxes.push(element);
			};

			// Init WOW.js and get instance
			var wow = new WOW();
			wow.init();
		}

		// remove `role` attributes from .slick-track and .slick-slide per accessibility recommendations
		function slickRemoveRoleAttributes(event, slick) {
			setTimeout(() => {
				slick.$slideTrack.removeAttr('role')
				slick.$slides.removeAttr('role')
			})
		}

		$(".slider-latest-module")
			.on('init', slickRemoveRoleAttributes)
			.slick({
				dots: false,
				infinite: true,
				slidesToShow: 5,
				centerMode: false,
				vertical: false,
				variableWidth: true,
				prevArrow: $(".module-list-thumbnail-row-section .prev-slider"),
				nextArrow: $(".module-list-thumbnail-row-section .next-slider"),
			});

		$('.custom-header .menu-desktop-custom a[target="_blank"]').addClass(
			"open-newtab"
		);
		$('.link-default-not-btn[target="_blank"]').addClass("open-newtab");
		$('.col-item-card-grid .link-btn[target="_blank"]').addClass("open-newtab");
		$('.col-item-thumbnail-row .link-btn[target="_blank"]').addClass(
			"open-newtab"
		);

		$(".detail-img-about-video .video-about")
			.parent()
			.click(function () {
				if ($(this).children(".video-about").get(0).paused) {
					$(this).children(".video-about").get(0).play();
					$(this).children(".img-video-about").css("z-index", "-1");

					$(this).children(".playpause-about").fadeOut();
					$(this).children(".playpause-about").css("z-index", "-1");
				} else {
					$(this).children(".video-about").get(0).pause();
					$(this).children(".img-video-about").css("z-index", "-9");

					$(this).children(".playpause-about").fadeIn();
					$(this).children(".playpause-about").css("z-index", "10");
				}
			});

		$(".navbar-inverse .navbar-toggle").click(function () {
			$(this).toggleClass("clicked");
			$("body").toggleClass("opened-menu");
			$("body .navbar-collapse.collapse").toggleClass("in");
			isClicked = true;
		});

		$(".slider-testimonials-module")
			.on('init', slickRemoveRoleAttributes)
			.slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				centerMode: false,
				autoplay: false,
				autoplaySpeed: 3000,
			});

		$('.slider-gallery-module')
			.on('init', slickRemoveRoleAttributes)
			.slick({
				dots: false,
				infinite: true,
				centerMode: false,
				vertical: false,
				variableWidth: true,
				prevArrow: $('.gallery-nav-slider .prev-slider'),
				nextArrow: $('.gallery-nav-slider .next-slider'),
			})

		$(".wp-block-acf-photo-slider").each(function () {
			$(this)
				.find(".slider-photos")
				.on('init', slickRemoveRoleAttributes)
				.slick({
					dots: false,
					infinite: false,
					centerMode: false,
					vertical: false,
					variableWidth: true,
					prevArrow: $(this).find(".slider-pagination-prev"),
					nextArrow: $(this).find(".slider-pagination-next"),
				});
		});

		$(".wp-block-acf-post-slider").each(function () {
			$(this)
				.find(".slider-posts")
				.on('init', slickRemoveRoleAttributes)
				.slick({
					dots: false,
					infinite: true,
					centerMode: false,
					vertical: false,
					variableWidth: true,
					prevArrow: $(this).find(".slider-pagination-prev"),
					nextArrow: $(this).find(".slider-pagination-next"),
				});
		});

		$(".wp-block-acf-card-slider").each(function () {
			$(this)
				.find(".slider-cards")
				.on('init', slickRemoveRoleAttributes)
				.slick({
					dots: false,
					infinite: true,
					centerMode: false,
					vertical: false,
					variableWidth: true,
					prevArrow: $(this).find(".slider-pagination-prev"),
					nextArrow: $(this).find(".slider-pagination-next"),
				});
		});

		const visualGrid = {
			init() {
				$("#wp-admin-bar-top-secondary")
					.append(
						`
						<li class="admin-bar-grid">
							<div class="ab-item ab-empty-item">
								<button type="button" class="js-toggle-grid border-0 bg-transparent text-[#f0f0f1]">Toggle Grid</button>
							</div>
						</li>
					`
					)
					.on("click", "button.js-toggle-grid", () => {
						$("#visual-grid").toggleClass("opacity-0");
						const enabled = !$("#visual-grid").hasClass("opacity-0");
						localStorage.setItem("visual-grid", enabled);
					});

				const enabled = localStorage.getItem("visual-grid") === "true";
				if (enabled) {
					$("#visual-grid").toggleClass("opacity-0", !enabled);
				}
			},
		};
		visualGrid.init();
	});
})(jQuery);
